export const getBSWholeWheatBagelsPackage = newProduct => {
  const newBSWholeWheatBagelsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatBagelsPackage
}

export const updateBSWholeWheatBagelsPackage = newProduct => {
  const newBSWholeWheatBagelsPackage = {
    UPC: newProduct.UPC,
    Size: newProduct.Size,
  }
  return newBSWholeWheatBagelsPackage
}
